export default "__VITE_ASSET__BwVEa0yW__"